import { useEffect, useRef, useState } from "react";
import Apiservice from "../Apiservice";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

const AddSite = () => {
    const navigate = useNavigate();
    const [roles, setRoles] = useState([]);
    const [profileImage, setProfileImage] = useState(null);
    const [preview, setPreview] = useState("");
    const [errors, setErrors] = useState({});

    const siteNameRef = useRef("");
    const countryCodeRef = useRef("+65");
    const mobileNoRef = useRef("");
    const emailIdRef = useRef("");
    // const userNameRef = useRef("");
    // const passwordRef = useRef("");
    const unitNoRef = useRef("");
    const streetRef = useRef("");
    const countryRef = useRef("Singapore");
    const pincodeRef = useRef("");
    const [requiredRoles, setRequiredRoles] = useState({});
    const latitudeRef = useRef(0);
    const longitudeRef = useRef(0);

    useEffect(() => {
        const token = localStorage.getItem("access_token");

        // Define custom headers
        const headers = {
            access_token: token, // Pass the token in the Authorization header
        };
        const fetchData = async () => {
            let result = await Apiservice.GetAllRoles(headers);
            if (result.success === true) {
                setRoles(result.data);
                console.log(result.data);
            } else {
                alert("First Add Atleast one role")
            }
        };
        fetchData();
    }, [])

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        setProfileImage(file);

        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                setPreview(reader.result);
            };
            reader.readAsDataURL(file);
        }
    };

    const handleRoleChange = (roleId, value) => {
        setRequiredRoles(prev => ({
            ...prev,
            [roleId]: parseInt(value || 0)
        }));
    };
    const handleSubmit = async () => {
        if (!validateForm()) {
            return;
        }

        const formData = new FormData();
        // formData.append("profileImage", profileImage);
        formData.append("siteName", siteNameRef.current.value);
        formData.append("countryCode", countryCodeRef.current.value);
        formData.append("mobileNo", mobileNoRef.current.value);
        formData.append("emailId", emailIdRef.current.value);
        // formData.append("userName", userNameRef.current.value);
        // formData.append("password", passwordRef.current.value);
        formData.append("unitNo", unitNoRef.current.value);
        formData.append("street", streetRef.current.value);
        formData.append("country", countryRef.current.value);
        formData.append("pincode", pincodeRef.current.value);
        // const formattedData = {};
        // roles.forEach(role => {
        //     if (role.id !== 1 && requiredRoles[role.id]) {
        //         // Example: Add your custom logic here to rename keys
        //         // formattedData[role.name.toLowerCase()] = requiredRoles[role.id];
        //         formattedData[`role_${role.id}`] = requiredRoles[role.id];
        //     }
        // });
        const formattedRoles = {};

        roles.forEach(role => {
            if (parseInt(role.id) !== 1) {
                formattedRoles[role.id] = requiredRoles[role.id] ?? 0;
            }
        });

        formData.append("requiredRoles", JSON.stringify(formattedRoles));
        formData.append('latitude', latitudeRef.current.value);
        formData.append('longitude', longitudeRef.current.value);

        try {

            // const token = localStorage.getItem("access_token");
            //  // const headers = { access_token: token };
            //  // const result = await Apiservice.AddSite(formData, headers);
            const result = await Apiservice.AddSite(formData);

            if (result.success) {
                await Swal.fire({
                    icon: "success",
                    title: "Success",
                    text: "Site added successfully.",
                    confirmButtonColor: "#3085d6",
                    confirmButtonText: "OK"
                });

                navigate("/sites");
            } else {
                Swal.fire({
                    icon: "warning",
                    title: "Warning",
                    text: result.message,
                    confirmButtonColor: "#f0ad4e"
                });
            }
        } catch (error) {
            console.error("Error submitting form:", error);

            Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "An error occurred. Please try again later.",
                confirmButtonColor: "#d33"
            });
        }
    };

    const validateForm = () => {
        const newErrors = {};

        if (!siteNameRef.current?.value?.trim()) {
            newErrors.siteName = "Site Name is required";
        }



        // if (!unitNoRef.current.value || isNaN(unitNoRef.current.value)) {
        //     newErrors.unitNo = "Unit Level is required and must be a number";
        // }

        if (!unitNoRef.current.value) {
            newErrors.unitNo = "Unit Level is required";
        }

        if (!streetRef.current.value.trim()) {
            newErrors.street = "Street is required";
        }

        if (!countryRef.current.value.trim()) {
            newErrors.country = "Country is required";
        }

        const pincode = pincodeRef.current?.value?.trim(); // remove spaces

        if (!pincode || isNaN(pincode) || parseInt(pincode) <= 0) {
            newErrors.pincode = "Pincode is required";
        }

        if (emailIdRef.current.value.length > 0) {
            if (!emailIdRef.current.value.trim() || !/\S+@\S+\.\S+/.test(emailIdRef.current.value)) {
                newErrors.emailId = "Valid Email is required";
            }
        }

        if (!mobileNoRef.current.value.trim() || isNaN(mobileNoRef.current.value)) {
            newErrors.mobileNo = "Valid Contact Number is required";
        }

        // if (!userNameRef.current.value.trim()) {
        //     newErrors.userName = "User ID is required";
        // }

        // if (!passwordRef.current.value.trim()) {
        //     newErrors.password = "Password is required";
        // }

        // if (!profileImage) {
        //     newErrors.profileImage = "Profile Image is required";
        // }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    return (
        <div className="container-fluid p-md-2 p-1 card shadow" style={{ userSelect: 'none' }}>
            <div className="row">
                <div className="row mb-1 sticky-top z-3 p-md-2 p-0">
                    <div className="col text-center">
                        <h4>Add New Site</h4>
                    </div>
                </div>

                <div className="row p-md-2 m-md-2">
                    <div className="col-md-7 col-12">
                        <div className="form">
                            {Object.entries({
                                siteName: "Site Name",
                                unitNo: "Unit Level",
                                street: "Street",
                                country: "Country",
                                pincode: "Pincode",
                                emailId: "Email",
                                mobileNo: "Contact No.",
                                // userName: "User ID",
                                // password: "Password",
                                // profileImage: "Photo",
                                latitude: 'Latitude',
                                longitude: 'Longitude'
                            }).map(([key, label]) => (
                                <div className="row mb-2" key={key}>
                                    <div className="col-md-3 col-3">
                                        <label htmlFor={key} className="form-label">
                                            {label}
                                        </label>
                                    </div>
                                    <div className="col-1">:</div>
                                    <div className="col">
                                        {key === "profileImage" ? (
                                            <input
                                                type="file"
                                                accept="image/*"
                                                className={`form-control form-control-sm ${errors[key] ? "is-invalid" : ""}`}
                                                onChange={handleFileChange}
                                            />
                                        ) : key === "mobileNo" ? (
                                            <div className="row">
                                                <div className="col-md-3 mb-1">
                                                    <input
                                                        type="text"
                                                        className="form-control form-control-sm"
                                                        defaultValue="+65"
                                                        ref={countryCodeRef}

                                                    />
                                                </div>
                                                <div className="col">
                                                    <input
                                                        type="number"
                                                        className={`form-control form-control-sm ${errors[key] ? "is-invalid" : ""}`}
                                                        ref={mobileNoRef}
                                                    />
                                                </div>
                                            </div>
                                        ) : key === "pincode" ? (
                                            <div className="row">
                                                <div className="col">
                                                    <input
                                                        type="number"
                                                        className={`form-control form-control-sm ${errors[key] ? "is-invalid" : ""}`}
                                                        ref={pincodeRef}
                                                    />
                                                </div>
                                            </div>
                                        ) : (
                                            <input
                                                type="text"
                                                className={`form-control form-control-sm ${errors[key] ? "is-invalid" : ""}`}
                                                ref={{
                                                    siteName: siteNameRef,
                                                    unitNo: unitNoRef,
                                                    street: streetRef,
                                                    country: countryRef,
                                                    emailId: emailIdRef,
                                                    mobileNo: mobileNoRef,
                                                    latitude: latitudeRef,
                                                    longitude: longitudeRef
                                                }[key]}
                                            />
                                        )}
                                        {errors[key] && <div className="invalid-feedback">{errors[key]}</div>}
                                    </div>
                                </div>
                            ))}

                        </div>
                    </div>
                    <div className="col-md-5 col-12">
                        {roles.length > 0 && (
                            <>
                                <div className="row mb-2">
                                    <h6>Assign Number of Roles for Site</h6>
                                </div>

                                {roles.map((role) => (
                                    parseInt(role.id) !== 1 && (
                                        <div className="row mb-2" key={role.id}>
                                            <div className="col-md-6 col-6">{role.name}</div>
                                            <div className="col-1">:</div>
                                            <div className="col">
                                                <input
                                                    type="number"
                                                    className="form-control form-control-sm"
                                                    onChange={(e) => handleRoleChange(role.id, e.target.value)}
                                                />
                                            </div>
                                        </div>
                                    )
                                ))}
                            </>
                        )}

                    </div>

                    {/* <div className="col-md-4 text-center">
                    {preview && (
                        <img
                            src={preview}
                            alt="Preview"
                            className="img-fluid border"
                            style={{ maxWidth: "100%", maxHeight: "200px" }}
                        />
                    )}
                    {errors[profileImage] && <div className="invalid-feedback">{errors[profileImage]}</div>}
                </div> */}
                </div>

                <div className="row mb-2">
                    <div className="col text-center">
                        <button className="btn btn-primary btn-sm" onClick={handleSubmit}>
                            Save
                        </button>
                    </div>
                </div>

            </div>


        </div>
    );
};

export default AddSite;
